import React from 'react';
import { ThemeProvider } from 'styled-components';

const theme = {
  colors: {
    vermilion: 'hsl(354deg 83% 62%)',
    lightGreen: 'hsl(174deg 33% 54%)',
    white: 'hsl(0deg, 0%, 100%)',
    black: 'hsl(0deg, 0%, 0%)',
    blackEightySeven: 'hsl(0deg, 0%, 0%,87%)',
    blackEighty: 'hsl(0deg, 0%, 0%,80%)',
    blackSixty: 'hsl(0deg, 0%, 0%,60%)',
    blackForty: 'hsl(0deg, 0%, 0%,40%)',
    borderColor: 'hsl(0deg, 0%, 0%,10%)',
    lightGrey: 'hsl(0deg, 0%, 0%,4%)',
    grey: 'hsl(0deg 0% 65.1%)',
  },
  fontSizes: {
    xxSmall: 'clamp(0.625rem, 0.594rem + 0.16vw, 0.75rem)',
    xSmall: 'clamp(0.75rem, 0.716rem + 0.17vw, 0.875rem)',
    small: 'clamp(0.875rem, 0.841rem + 0.17vw, 1rem)',
    medium: 'clamp(1rem, 0.932rem + 0.34vw, 1.25rem)',
    large: '3em',
  },
  fontFamily: 'Montserrat',
  breakPoints: {
    mobileS: '320px',
    mobileM: '600px',
    mobileL: '720px',
  },
  weight: {
    light: '400',
    medium: '500',
    dark: '600',
  },
  letterSpacing: {
    sBroad: '1px',
    mBroad: '2px',
    lBroad: '3px',
    xlBroad: '4px',
  },
};

const Theme = ({ children }) => (
  <ThemeProvider theme={theme}>{children}</ThemeProvider>
);

export default Theme;
